<template>
  <div class="sort-item">
    <el-select :disabled="disabled" v-model="sheet.key" filterable>
      <el-option
        v-for="item in filterSheetList"
        :key="item._cid"
        :value="item._cid"
        :label="item.name"
      ></el-option>
    </el-select>
    <el-select :disabled="disabled" v-model="sheet.direction">
      <el-option
        v-for="item in sortOptions"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      ></el-option>
    </el-select>
    <el-button
      v-show="!disabled"
      class="el-icon-remove-outline"
      :disabled="from !== 'refControl' && selectSheets.length <= 1"
      type="text"
      @click="$emit('remove')"
      style="font-size: 20px;padding:10px 0;"
    ></el-button>
    <el-button
      v-show="!disabled"
      class="el-icon-circle-plus-outline"
      type="text"
      @click="$emit('add')"
      style="font-size: 20px;padding:10px 0;"
    ></el-button>
  </div>
</template>
<script>
import { sortOptions } from "./static"
export default {
  name: "sort-item",
  data() {
    return {
      sortOptions
    }
  },
  props: {
    sheetList: Array,
    selectSheets: Array,
    sheet: Object,
    disabled: Boolean,
    from: String
  },
  computed: {
    filterSheetList() {
      let selectSheets = this.selectSheets.filter(x => x != this.sheet.key)
      return this.sheetList.filter(x => !selectSheets.includes(x._cid))
    }
  }
}
</script>
<style lang="scss" scoped>
.sort-item {
  display: flex;
  align-items: center;
  .el-select {
    margin-right: 5px;
  }
  .el-button + .el-button {
    margin-left: 4px;
  }
}
</style>
